import HeaderComponent from '@/components/Header/HeaderComponent.vue';
import SidebarComponent from '@/components/Sidebar/SidebarComponent.vue';
import MobileSidebar from '@/components/MobileSidebar/MobileSidebar.vue';

export default {
  header: HeaderComponent,
  sidebar: SidebarComponent,
  mobileSidebar: MobileSidebar,
};
